import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0a83a03f&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=0a83a03f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83a03f",
  null
  
)

export default component.exports